export const DEPARTMENT_SET= {
    // установить выбранную коллекцию подразделений в MasterApp
    SET_DEPARTMENT_COLLECTION: "DEPARTMENT | SET_DEPARTMENT_COLLECTION",
}